module.exports = __webpack_public_path__ + "static/media/timer-off.a53420d5.svg";